export default __webpack_public_path__ + "static/media/file.8c2e9bf2.svg";